import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { ReactNode, useCallback, useState } from "react";
import { useAddSummaryMutation } from "../../../redux/Hire/interviewQuestionSlice";

interface EditableDraftSummaryProps {
  initialSummary: string;
  onSave?: (summary: string) => void;
  interviewId?: string;
  extraAction?: ReactNode;
}

const EditableDraftSummary = ({
  initialSummary,
  onSave,
  interviewId,
  extraAction,
}: EditableDraftSummaryProps) => {
  const [editing, setEditing] = useState(false);
  const [summary, setSummary] = useState(initialSummary);
  const [addSummary, { isLoading }] = useAddSummaryMutation();

  const submitSummary = useCallback(async () => {
    if (interviewId && summary) {
      await addSummary({
        interviewId: interviewId,
        interviewSummary: summary,
      }).unwrap();
      setEditing(false);
    }
  }, [addSummary, interviewId, summary]);

  return (
    <Grid container gap={1} width={"100%"}>
      <Grid item xs={12}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              color="#1E293A"
              fontSize={"18px"}
              lineHeight={"18px"}
              fontWeight={600}
              gutterBottom
            >
              Meeting Summary
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {!editing && (
              <Button
                variant="text"
                size="small"
                onClick={() => setEditing(true)}
              >
                Edit Summary
              </Button>
            )}
            {editing && (
              <Button
                variant="text"
                color="primary"
                size="small"
                onClick={submitSummary}
                disabled={isLoading}
                sx={{ minWidth: 80 }}
              >
                {isLoading ? <CircularProgress size={20} /> : "Save"}
              </Button>
            )}
            {extraAction && (
              <span style={{ marginLeft: 8 }}>{extraAction}</span>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} item>
        {editing ? (
          <TextField
            multiline
            minRows={4}
            inputProps={{
              style: { fontSize: "14px", lineHeight: "22px", color: "#667086" },
            }}
            fullWidth
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            disabled={isLoading}
          />
        ) : (
          <Typography
            sx={{ whiteSpace: "pre-line" }}
            color="#667086"
            fontSize={"14px"}
            lineHeight={"22px"}
          >
            {summary}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default EditableDraftSummary;
